<div class="column has-text-centered">
  <div class="img-row" *ngFor="let image of albums; let i=index">
    <img class="img-frame" [src]="getSantizeUrl(image.thumb)" (click)="open(i)"/>
  </div>
</div>
